<template>
  <div class="select-doctor">

    <div class="row">
      <div class="col-md-6 col-lg-4 col-xxl-3">
        <div
          class="d-flex align-items-center c-pointer"
          @click="goToCareTeam()"
        >
          <img
            src="../../../public/icons/lessthan-blur-gray.svg"
            alt=""
          >
          <p class="mb-0 txt-gray-blur fs-14 fw-500">Quay lại mời bác sĩ</p>
        </div>
        <p class="fs-28 fw-500 txt-black mb-3">Danh sách bác sĩ</p>

      </div>
      <div class="col-md-6 col-lg-8 col-xxl-9">
        <div class="input-group search-box">
          <input
            type="text"
            v-model="search"
            @keypress.enter="searchDoctor"
            class="form-control"
            placeholder="Tìm kiếm bác sĩ"
          >
          <span class="input-group-text bg-white c-pointer" @click="searchDoctor">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="10"
                cy="10"
                r="7.25"
                stroke="#3B3B40"
                stroke-width="1.5"
              />
              <path
                d="M15.5 15.5L21.5 21.5"
                stroke="#3B3B40"
                stroke-width="1.5"
              />
            </svg>

          </span>
        </div>
      </div>
    </div>
    <div
      class="row pt-4"
      v-if="doctors && doctors.data"
    >
      <div
        class="col-xl-3 col-lg-4 col-sm-6"
        v-for="doctor in doctors.data"
        :key="doctor.id"
      >
        <div class="doctor-item">
          <div class="avatar">
            <img
              v-if="!doctor.user || !doctor.user.avatar"
              src="/images/common/df-avatar.svg"
              alt=""
            >
            <img
              v-if="doctor.user && doctor.user.avatar"
              :src="getUrlImage(doctor.user.avatar)"
              alt=""
            >
          </div>
          <p
            class="text-center fs-18 fw-500 txt-black max-line-2"
            style="height: 44px"
          >{{doctor.name}}</p>
          <div class="info">
            <div class="d-flex mb-1">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="me-1"
              >
                <path
                  d="M5.33338 14.6667H10.6667C13.3467 14.6667 13.8267 13.5933 13.9667 12.2867L14.4667 6.95333C14.6467 5.32667 14.18 4 11.3334 4H4.66671C1.82005 4 1.35338 5.32667 1.53338 6.95333L2.03338 12.2867C2.17338 13.5933 2.65338 14.6667 5.33338 14.6667Z"
                  stroke="#476DD6"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M5.33337 3.99967V3.46634C5.33337 2.28634 5.33337 1.33301 7.46671 1.33301H8.53337C10.6667 1.33301 10.6667 2.28634 10.6667 3.46634V3.99967"
                  stroke="#476DD6"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M9.33329 8.66667V9.33333C9.33329 9.34 9.33329 9.34 9.33329 9.34667C9.33329 10.0733 9.32663 10.6667 7.99996 10.6667C6.67996 10.6667 6.66663 10.08 6.66663 9.35333V8.66667C6.66663 8 6.66663 8 7.33329 8H8.66663C9.33329 8 9.33329 8 9.33329 8.66667Z"
                  stroke="#476DD6"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M14.4334 7.33301C12.8934 8.45301 11.1334 9.11967 9.33337 9.34634"
                  stroke="#476DD6"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M1.7467 7.51367C3.2467 8.54034 4.94004 9.16034 6.6667 9.35367"
                  stroke="#476DD6"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <p class="mb-0 fs-12 txt-black text-doctor-info max-line-2">{{doctor.chuc_vu || 'Chưa cập nhật'}}</p>
            </div>
            <div class="d-flex mb-1">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="me-1"
              >
                <path
                  d="M8.00004 8.95297C9.1488 8.95297 10.08 8.02172 10.08 6.87297C10.08 5.72422 9.1488 4.79297 8.00004 4.79297C6.85129 4.79297 5.92004 5.72422 5.92004 6.87297C5.92004 8.02172 6.85129 8.95297 8.00004 8.95297Z"
                  stroke="#476DD6"
                  stroke-width="1.5"
                />
                <path
                  d="M2.4133 5.65968C3.72664 -0.113657 12.28 -0.106991 13.5866 5.66634C14.3533 9.05301 12.2466 11.9197 10.4 13.693C9.05997 14.9863 6.93997 14.9863 5.5933 13.693C3.7533 11.9197 1.64664 9.04634 2.4133 5.65968Z"
                  stroke="#476DD6"
                  stroke-width="1.5"
                />
              </svg>

              <p class="mb-0 fs-12 txt-black text-doctor-info max-line-2">{{doctor.address || 'Chưa cập nhật'}}</p>
            </div>
            <div class="d-flex mb-1">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="me-1"
              >
                <path
                  d="M12.6667 5.33301C12.1954 5.33183 11.7388 5.49757 11.378 5.80087C11.0172 6.10416 10.7754 6.52541 10.6955 6.98994C10.6157 7.45447 10.7028 7.93229 10.9416 8.33868C11.1804 8.74507 11.5554 9.05379 12 9.21012V10.333C12 11.1287 11.684 11.8917 11.1214 12.4543C10.5588 13.0169 9.79569 13.333 9.00004 13.333C8.20439 13.333 7.44133 13.0169 6.87872 12.4543C6.31611 11.8917 6.00004 11.1287 6.00004 10.333V9.93946C6.93112 9.78147 7.77636 9.29939 8.38634 8.57843C8.99633 7.85747 9.33177 6.94406 9.33337 5.99967V1.99967C9.33337 1.82286 9.26314 1.65329 9.13811 1.52827C9.01309 1.40325 8.84352 1.33301 8.66671 1.33301H7.33337C7.15656 1.33301 6.98699 1.40325 6.86197 1.52827C6.73695 1.65329 6.66671 1.82286 6.66671 1.99967C6.66671 2.17649 6.73695 2.34605 6.86197 2.47108C6.98699 2.5961 7.15656 2.66634 7.33337 2.66634H8.00004V5.99967C8.00004 6.70692 7.71909 7.3852 7.21899 7.88529C6.7189 8.38539 6.04062 8.66634 5.33337 8.66634C4.62613 8.66634 3.94785 8.38539 3.44776 7.88529C2.94766 7.3852 2.66671 6.70692 2.66671 5.99967V2.66634H3.33337C3.51019 2.66634 3.67975 2.5961 3.80478 2.47108C3.9298 2.34605 4.00004 2.17649 4.00004 1.99967C4.00004 1.82286 3.9298 1.65329 3.80478 1.52827C3.67975 1.40325 3.51019 1.33301 3.33337 1.33301H2.00004C1.82323 1.33301 1.65366 1.40325 1.52864 1.52827C1.40361 1.65329 1.33337 1.82286 1.33337 1.99967V5.99967C1.33498 6.94406 1.67042 7.85747 2.2804 8.57843C2.89039 9.29939 3.73563 9.78147 4.66671 9.93946V10.333C4.66671 11.4823 5.12325 12.5845 5.93591 13.3971C6.74857 14.2098 7.85077 14.6663 9.00004 14.6663C10.1493 14.6663 11.2515 14.2098 12.0642 13.3971C12.8768 12.5845 13.3334 11.4823 13.3334 10.333V9.21016C13.778 9.05383 14.153 8.7451 14.3918 8.3387C14.6306 7.93231 14.7177 7.4545 14.6379 6.98997C14.558 6.52543 14.3162 6.10418 13.9554 5.80089C13.5946 5.49759 13.1381 5.33184 12.6667 5.33301ZM12.6667 7.99967C12.5349 7.99967 12.406 7.96058 12.2963 7.88732C12.1867 7.81407 12.1012 7.70995 12.0508 7.58813C12.0003 7.46631 11.9871 7.33227 12.0129 7.20295C12.0386 7.07363 12.1021 6.95484 12.1953 6.8616C12.2885 6.76837 12.4073 6.70487 12.5366 6.67915C12.666 6.65343 12.8 6.66663 12.9218 6.71709C13.0436 6.76755 13.1478 6.85299 13.221 6.96263C13.2943 7.07226 13.3334 7.20115 13.3334 7.33301C13.3331 7.50975 13.2628 7.67918 13.1379 7.80416C13.0129 7.92913 12.8434 7.99945 12.6667 7.99967Z"
                  fill="#476DD6"
                />
              </svg>

              <p class="mb-0 fs-12 txt-pri text-doctor-info max-line-2">{{doctor.majors || 'Chưa cập nhật'}}</p>
            </div>
          </div>
          <div class="bottom" :set="selected = checkSelected(doctor)">
            <div
              class="btn btn-pri btn-invite"
              @click="selectDoctor(doctor)"
              :class="selected ? 'disabled' : ''"
            >
              <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                v-if="!selected"
              >
                <path
                  d="M2.75 8.5C2.75 5 4.75 3.5 7.75 3.5H17.75C20.75 3.5 22.75 5 22.75 8.5V15.5C22.75 19 20.75 20.5 17.75 20.5H7.75"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M17.75 9L14.62 11.5C13.59 12.32 11.9 12.32 10.87 11.5L7.75 9"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M2.75 16.5H8.75"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M2.75 12.5H5.75"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span class="fw-500 fs-16 ms-2">{{selected ? 'Đã mời' : 'Mời'}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="d-flex justify-content-center align-items-center">
          <div
            v-if="doctors.current_page > 1"
            class="d-flex justify-content-center align-items-center me-3 c-pointer"
            @click="privPage()"
          >
            <svg
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="priv-icon"
            >
              <rect
                x="0.5"
                y="0.5"
                width="47"
                height="47"
                rx="23.5"
                stroke="#E7EAF5"
              />
              <path
                d="M13.5 23C12.9477 23 12.5 23.4477 12.5 24C12.5 24.5523 12.9477 25 13.5 25V23ZM34.2071 24.7071C34.5976 24.3166 34.5976 23.6834 34.2071 23.2929L27.8431 16.9289C27.4526 16.5384 26.8195 16.5384 26.4289 16.9289C26.0384 17.3195 26.0384 17.9526 26.4289 18.3431L32.0858 24L26.4289 29.6569C26.0384 30.0474 26.0384 30.6805 26.4289 31.0711C26.8195 31.4616 27.4526 31.4616 27.8431 31.0711L34.2071 24.7071ZM13.5 25H33.5V23H13.5V25Z"
                fill="#476DD6"
              />
            </svg>
            <p class="mb-0 txt-pri fs-14 fw-500 ms-2">Trang trước</p>
          </div>
          <div
            v-if="doctors.current_page < doctors.last_page"
            class="d-flex justify-content-center align-items-center ms-3 c-pointer"
            @click="nextPage()"
          >
            <p class="mb-0 txt-pri fs-14 fw-500 me-2">Trang sau</p>
            <svg
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.5"
                y="0.5"
                width="47"
                height="47"
                rx="23.5"
                stroke="#E7EAF5"
              />
              <path
                d="M13.5 23C12.9477 23 12.5 23.4477 12.5 24C12.5 24.5523 12.9477 25 13.5 25V23ZM34.2071 24.7071C34.5976 24.3166 34.5976 23.6834 34.2071 23.2929L27.8431 16.9289C27.4526 16.5384 26.8195 16.5384 26.4289 16.9289C26.0384 17.3195 26.0384 17.9526 26.4289 18.3431L32.0858 24L26.4289 29.6569C26.0384 30.0474 26.0384 30.6805 26.4289 31.0711C26.8195 31.4616 27.4526 31.4616 27.8431 31.0711L34.2071 24.7071ZM13.5 25H33.5V23H13.5V25Z"
                fill="#476DD6"
              />
            </svg>

          </div>

        </div>
      </div>
    </div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="modalNotInvite"
      tabindex="-1"
      aria-labelledby="modalNotInviteTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header border-0">
            <h5
              class="modal-title fs-18 txt-black fw-500"
              id="modalNotInviteTitle"
            >Lời nhắn cho bác sĩ</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div
              class="input-group note"
              :class="note ? 'bd-pri': ''"
            >
              <div class="input-group-text bg-white border-top-0 border-start-0 radius-0">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.4"
                    d="M7 3L17 3C20 3 22 4.5 22 8V11.14C22 11.87 21.25 12.33 20.58 12.04C19.48 11.56 18.23 11.38 16.92 11.59C14.3 12.02 12.16 14.09 11.63 16.69C11.48 17.45 11.46 18.19 11.56 18.9C11.64 19.49 11.16 20.01 10.57 20.01H7C4 20.01 2 18.51 2 15.01L2 8.01001C2 4.50001 4 3 7 3Z"
                    fill="#476DD6"
                  />
                  <path
                    d="M12 11.87C11.16 11.87 10.31 11.61 9.66003 11.08L6.53002 8.57996C6.21002 8.31996 6.15003 7.84997 6.41003 7.52997C6.67003 7.20997 7.14001 7.14997 7.46001 7.40997L10.59 9.90997C11.35 10.52 12.64 10.52 13.4 9.90997L16.53 7.40997C16.85 7.14997 17.33 7.19997 17.58 7.52997C17.84 7.84997 17.79 8.32996 17.46 8.57996L14.33 11.08C13.69 11.61 12.84 11.87 12 11.87Z"
                    fill="#476DD6"
                  />
                  <path
                    d="M18 13C15.24 13 13 15.23 13 18C13 20.76 15.24 23 18 23C20.77 23 23 20.76 23 18C23 15.23 20.77 13 18 13ZM20.05 17.55L19.68 17.91L17.51 20.09C17.41 20.18 17.22 20.28 17.08 20.3L16.1 20.44C15.75 20.49 15.5 20.24 15.55 19.89L15.69 18.91C15.71 18.77 15.8 18.58 15.9 18.48L18.08 16.31L18.44 15.94C18.68 15.7 18.95 15.54 19.23 15.54C19.47 15.54 19.74 15.65 20.04 15.94C20.7 16.6 20.49 17.11 20.05 17.55Z"
                    fill="#476DD6"
                  />
                </svg>

              </div>
              <input
                type="text"
                class="form-control txt-pri"
                v-model="note"
                placeholder="Viết lời nhắn để Bác sĩ tiếp nhận nhanh hơn"
              >
            </div>
          </div>
          <div class="modal-footer border-0 justify-content-center">
            <button
              type="button"
              class="btn btn-pri radius-15 btn-send"
              @click="sendInvite()"
            >Gửi lời mời</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appUtils from '../../utils/appUtils'
export default {
  name: 'SelectCareTeamDoctor',
  data () {
    return {
      doctors: [],
      page: 1,
      last_page: 0,
      search: '',
      loading: false,
      note: '',
      slt_doctor: null,
      care_team: []
    }
  },
  mounted () {
    const self = this
    self.page = self.$route.query.page || 1
    self.search = self.$route.query.search || ''
    if (!this.$route.params.pdid || !this.$route.params.type || (this.$route.params.type && [1, 2, 4].findIndex(t => t === parseInt(this.$route.params.type)) < 0)) self.goToCareTeam()
    setTimeout(() => {
      self.getDoctors()
      self.getPersonDisease()
    }, 50)
    self.$nextTick(() => {
      window.$('#modalNotInvite').on('hidden.bs.modal', function (e) {
        self.slt_doctor = null
      })
    })
  },
  methods: {
    async getPersonDisease () {
      const self = this
      self.care_team = []
      await self.$rf.getRequest('AuthRequest').getDisease(self.$route.params.pdid, false).then((r) => {
        self.care_team = r.data?.care_team
      }).catch((e) => {
        window.$toast.open({
          message: 'Bạn không có quyền xem hồ sơ này hoặc đã có lỗi xảy ra',
          type: 'error'
        })
      })
    },
    checkSelected (doctor) {
      const self = this
      if (self.care_team?.care_team_doctor?.length) {
        return self.care_team.care_team_doctor.findIndex(dtr => dtr?.doctor?.id === doctor.id) > -1
      }
    },
    async getDoctors () {
      const self = this
      self.loading = false
      const params = {
        limit: 12,
        page: self.page || 1
      }
      const query = {
        page: self.page || 1
      }
      if (self.search) {
        params.search = self.search
        query.search = self.search
      }
      self.$router.push({ query: query }).catch(() => { })
      await self.$rf.getRequest('AuthRequest').getDoctors(params).then((r) => {
        self.doctors = r.data
      }).finally(() => {
        self.loading = false
      })
    },
    nextPage () {
      const self = this
      if (self.doctors?.last_page > self.doctors?.current_page) {
        self.page++
        setTimeout(() => {
          self.getDoctors()
        }, 50)
      }
    },
    privPage () {
      const self = this
      if (self.doctors?.current_page > 1) {
        self.page--
        setTimeout(() => {
          self.getDoctors()
        }, 50)
      }
    },
    searchDoctor () {
      const self = this
      self.page = 1
      setTimeout(() => {
        self.getDoctors()
      }, 50)
    },
    selectDoctor (doctor) {
      this.slt_doctor = doctor
      this.modalNote(true)
    },
    async sendInvite () {
      const self = this
      if (!self.slt_doctor || !self.$route.params.pdid || !self.$route.params.type) return
      self.loading = true
      const params = {
        person_diseases_id: self.$route.params.pdid,
        doctor_id: self.slt_doctor.id,
        invite_message: self.note,
        doctor_role: self.$route.params.type
      }
      await self.$rf.getRequest('AuthRequest').inviteDoctor(params).then((r) => {
        window.$toast.open({
          message: 'Đã gửi lời mời đến bác sĩ ' + self.slt_doctor.name,
          type: 'success'
        })
        self.slt_doctor = null
        self.modalNote(false)
        self.note = ''
        self.goToCareTeam()
      }).finally(() => {
        self.loading = false
      })
    },
    getUrlImage (path) {
      if (!path) return
      return appUtils.getDocumentURL(path)
    },
    goToCareTeam () {
      this.$router.push({ path: `/hssk/${this.$route.params.pdid}/moi-bac-si` })
    },
    modalNote (show) {
      return window.$('#modalNotInvite').modal(show ? 'show' : 'hide')
    }
  }
}
</script>

<style scoped>
.select-doctor {
  padding: 56px;
  background-color: #f7f7f9;
}
.search-box {
  height: 61px;
  border-radius: 31px;
}
.search-box .form-control,
.search-box .input-group-text {
  border-radius: 31px;
  border-color: #d5d2f9;
}
.search-box .form-control {
  border-right: 0 !important;
}
.doctor-item {
  height: 373px;
  position: relative;
  background-color: white;
  padding: 9px;
  margin-bottom: 16px;
  border-radius: 15px;
}
.bottom {
  position: absolute;
  bottom: 9px;
  padding-top: 7px;
  border-top: 1px solid #e0e0e0;
  width: calc(100% - 18px);
}
.avatar img {
  width: 106px;
  height: 106px;
  border-radius: 50%;
  margin: 0 auto;
}
.avatar {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}
.text-doctor-info {
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0px;
  text-align: left;
  height: 34px;
}
.btn-invite {
  width: 100%;
  height: 40px;
}
.btn-send {
  height: 50px;
  width: 250px;
}
.note .form-control {
  border-top: 0;
  border-left: 0;
  border-right: 0;
  border-radius: 0;
  color: #476dd6;
}
.priv-icon {
  transform: rotate(180deg);
}
</style>
